export const config = {
  auth_url: process.env.REACT_APP_AUTH_URL ?? "https://auth.pocketfilms.in",
  auth_url_source: process.env.REACT_APP_AUTH_URL_SOURCE ?? "https://auth.pocketfilms.in?source=distribute",
  api_url:
    process.env.REACT_APP_API_URL ?? "https://devadmin2.pocketfilms.in/api/v1",
  base_url:
    process.env.REACT_APP_BASE_URL ?? "https://distribute.pocketfilms.in",
  /** Public profile URLs shown in film/series custom-url fields */
  public_site_host:
    process.env.REACT_APP_PUBLIC_SITE_HOST ?? "pocketfilms.in",
};
